import React from "react";

const InputWrapper = ({
  isDisabled = false,
  focus = false,
  children,
  paddingClass = "",
  spaceClass = "",
}: {
  isDisabled?: boolean;
  focus?: boolean;
  children: React.ReactNode;
  paddingClass?: string;
  spaceClass?: string;
}) => {
  return (
    <div
      className={`flex items-center border rounded-2 w-full ${
        focus ? "border-darwin-primary-500" : "border-darwin-neutral-100"
      }  ${
        isDisabled
          ? "bg-darwin-neutral-50 text-darwin-neutral-600 cursor-not-allowed"
          : "bg-neutral-0"
      } ${paddingClass || ""} ${spaceClass || ""}`}
    >
      {children}
    </div>
  );
};

export default InputWrapper;
